const urlExtractor = (url, parts) => url.split('/').slice(0, parts).join('/');

export { urlExtractor };
